<template>
<div class="menu-item-option-items-viewer__chips">
  <section
    v-for="item in items"
    :class="{
      'pr-2': !hasMultipleItems,
    }"
    :key="`option-${optionIndex}-item-${item.index}`"
    class="menu-item-option-items-viewer__chips--chip"
  >
    <span>{{ item.name }}</span>
    <span v-if="item.price" class="pl-1">
      {{ item.price | commaFormat | priceFormat }}
    </span>
    <w-button
      v-if="hasMultipleItems"
      type="icon"
      @click="$emit('remove-item', item)"
    >
      <i class="font-base icon-circle-delete text-gray-300" />
    </w-button>
  </section>
</div>
</template>

<script>
import MenuItemOptionItemsViewer from './MenuItemOptionItemsViewer';

export default MenuItemOptionItemsViewer;
</script>

<style lang="scss" scoped>
@import 'MenuItemOptionItemsViewer';
</style>
